import {
  IAnalyticsEventGroupProperties,
  IAnalyticsGroupArgument,
} from './types';

export const getGroupEventProperties = (
  group: IAnalyticsGroupArgument,
): IAnalyticsEventGroupProperties => {
  return {
    object_type: 'group',
    object_name: group.name,
    object_id: group.id,
  };
};
